import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import styled from 'styled-components';
import {
  IndicatorSectionKey,
  IndicatorWithUpdate,
} from '../ImpactIndicator/utils';
import SummaryIcon from './SummaryIcon';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SectionRight from './SectionRight';
import { getEmptyIndicatorStageText } from '../ImpactIndicator/Stages/StageEmptyState';

interface ImpactSummarySectionProps {
  text: string;
  reportId: number;
  bottomBorder?: boolean;
  serviceGoal?: string;
  serviceType?: string;
  intermediaries?: string;
  isReportPassed?: boolean;
  sectionKey: IndicatorSectionKey;
  beneficiaryTerm: string | undefined;
  programName?: string;
  defaultIndicators: IndicatorWithUpdate[];
  selectedIndicators: IndicatorWithUpdate[];
  unselectedIndicators: IndicatorWithUpdate[];
  deletedIndicators: IndicatorWithUpdate[];
  handleRestoreIndicator: (
    sectionKey: IndicatorSectionKey,
    indicator: IndicatorWithUpdate,
    index: number,
  ) => unknown;
  handleAdd: (
    sectionKey: IndicatorSectionKey,
    indicator: IndicatorWithUpdate,
    index: number,
  ) => unknown;
  handleDelete: (
    sectionKey: IndicatorSectionKey,
    indicator: IndicatorWithUpdate,
    index: number,
  ) => unknown;
  handleIndicatorTextUpdate: (
    sectionKey: IndicatorSectionKey,
    text: string,
    index: number,
  ) => unknown;
}

const StyledDiv = styled.div<{ bottomBorder?: boolean }>`
  display: flex;
  padding-top: ${SPACERS.large};
  padding-bottom: ${SPACERS.medium};
  ${({ bottomBorder }) =>
    bottomBorder ? `border-bottom: 1px solid ${COLORS.grayLight};` : ''}
  .section {
    padding-top: ${SPACERS.small};
    padding-left: 25px;
    padding-right: 42px;
  }
  .warning {
    display: flex;
    align-items: center;
    max-width: 800px;
    svg {
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
  }
  .full-flex {
    flex: 1;
  }
`;

const ImpactSummarySection: React.FC<ImpactSummarySectionProps> = ({
  reportId,
  sectionKey,
  text,
  bottomBorder,
  deletedIndicators,
  programName,
  intermediaries,
  isReportPassed,
  serviceGoal,
  serviceType,
  defaultIndicators,
  selectedIndicators,
  unselectedIndicators,
  beneficiaryTerm,
  handleRestoreIndicator,
  handleAdd,
  handleDelete,
  handleIndicatorTextUpdate,
}) => {
  return (
    <>
      <StyledDiv bottomBorder={bottomBorder}>
        <div className="section">
          <SummaryIcon sectionKey={sectionKey} text={text} />
        </div>
        <div className="full-flex">
          {selectedIndicators.length === 0 &&
            sectionKey === 'capacityDevelopment' && (
              <div className="warning">
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  color={COLORS.warning}
                />
                <TrueImpactText>
                  {getEmptyIndicatorStageText(sectionKey)}
                </TrueImpactText>
              </div>
            )}
          <SectionRight
            selectedIndicators={selectedIndicators}
            handleDelete={handleDelete}
            sectionKey={sectionKey}
            unselectedIndicators={unselectedIndicators}
            handleAdd={handleAdd}
            programName={programName}
            intermediaries={intermediaries}
            isReportPassed={isReportPassed}
            serviceGoal={serviceGoal}
            serviceType={serviceType}
            beneficiaryTerm={beneficiaryTerm}
            deletedIndicators={deletedIndicators}
            handleRestoreIndicator={handleRestoreIndicator}
            handleIndicatorTextUpdate={handleIndicatorTextUpdate}
            reportId={reportId}
          />
        </div>
      </StyledDiv>
    </>
  );
};

export default ImpactSummarySection;
